import { createAction } from 'redux-actions'
import { get, identity } from 'lodash/fp'
import { Action, ThunkAction } from '../types/common'
import { query } from '../common/api'
import { SPECIES_QUERY, SPECIES_SET_GROUP_MUTATION } from './speciesQueries'

export type SpeciesGroup = 'pest' | 'animal'

export interface ISpecies {
  id: number
  sanaId: number
  name: string
  group: SpeciesGroup | null
  productsForshaw: number
  productsFrs: number
}

export const SET_SPECIES = 'SPECIES/SET_SPECIES'
export type SET_SPECIES = Action<ISpecies[]>
export const setSpecies = createAction<ISpecies[], ISpecies[]>(
  SET_SPECIES,
  identity,
)

export const UPDATE_SPECIES_GROUP = 'SPECIES/UPDATE_SPECIES_GROUP'
export type UPDATE_SPECIES_GROUP = Action<{ id: number; group: SpeciesGroup }>
export const updateSpeciesGroup = createAction(
  UPDATE_SPECIES_GROUP,
  (id: number, group: SpeciesGroup) => ({ id, group }),
)

export const requestSpecies =
  (): ThunkAction<Promise<void>> => async (dispatch) => {
    const response = await query(SPECIES_QUERY)
    dispatch(setSpecies(get('species', response) || []))
  }

export const setSpeciesGroup =
  (id: number, group: SpeciesGroup): ThunkAction<Promise<void>> =>
  async (dispatch) => {
    const response = await query(SPECIES_SET_GROUP_MUTATION, { id, group })
    const result = get('speciesSetGroup.result', response)

    if (result) {
      dispatch(updateSpeciesGroup(result.id, result.group))
    }
  }
